export const filtrosTypography = {
    color: 'white', fontSize: '15px', whiteSpace: 'nowrap'
}
